import { render, staticRenderFns } from "./CustomizedDetail.vue?vue&type=template&id=1c2eb019&scoped=true"
import script from "./CustomizedDetail.vue?vue&type=script&lang=js"
export * from "./CustomizedDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomizedDetail.vue?vue&type=style&index=0&id=1c2eb019&prod&lang=scss&scoped=true"
import style1 from "./CustomizedDetail.vue?vue&type=style&index=1&id=1c2eb019&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2eb019",
  null
  
)

export default component.exports